// extracted by mini-css-extract-plugin
export default {"Container":"ConfirmChangePassword_Container__t2iDI","Content":"ConfirmChangePassword_Content__idVyL"};